import store from '@/redux/store'
import { PRODUCT_ROUTE_MAP } from '@/modules/moduleSubscription/constants'
import { navigate } from '@/modules/layout/util/useInterceptedNavigate'

interface NavigateToShopProps {
  product?: keyof typeof PRODUCT_ROUTE_MAP
  selectActiveTrialProduct?: boolean
  scrollIntoPlans?: boolean
}

export default function navigateToShop(props: NavigateToShopProps) {
  const { product = null, selectActiveTrialProduct = false, scrollIntoPlans = false } = props
  const activeSubscriptions = store.getState().subscription.details.subscriptions
  let url = '/shop'

  const activeTrials = activeSubscriptions.filter(sub => sub.isTrial).length
  if (selectActiveTrialProduct && activeTrials === 1) {
    url += `/${PRODUCT_ROUTE_MAP[activeSubscriptions[0].typeOfSubscription]}`
  } else if (product) {
    url += `/${PRODUCT_ROUTE_MAP[product]}`
  }

  if (scrollIntoPlans) url += '#plans'

  return navigate(url)
}
